<template>
  <div>
      	<!--Page header-->
        <div class="page-header">
            <div class="page-leftheader">
                <h4 class="page-title mb-0 text-primary">Dashboard</h4>
            </div>
            <div class="page-rightheader">
                <div class="btn-list">
                    
                    <a class="btn btn-primary btn-pill" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
                    <div class="dropdown-menu border-0">
                            <a class="dropdown-item" id="dropdownToday" @click="fetchData('Today')">Letzte 24 Stunden</a>
                            <a class="dropdown-item" id="dropdownLastWeek" @click="fetchData('LastWeek')">Letzte 7 Tage</a>
                            <a class="dropdown-item" id="dropdownLastMonth" @click="fetchData('LastMonth')">Letzte 30 Tage</a>
                            <a class="dropdown-item active" id="dropdownAllTime" @click="fetchData('AllTime')">Gesamt</a>
                    </div>
                </div>
            </div>
        </div>
        <!--End Page header-->

        <!-- Row-1 -->
        <div class="row">
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash1">
                    <div class="card-body dashboardCard">
                        <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <span class="fs-14 font-weight-normal">Gesamte Nutzer</span>
                                    <h2 class="mb-2 number-font carn1 font-weight-bold">{{displayNumber(userAmount.amount)}}</h2>
                                </div>
                        </div>
                        <div class="headerChartContainer">
                            <div class="chart-wrapper">
                                <LineChart :chartData="userAmount.chartData" :options="userAmount.chartOptions"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash2">
                    <div class="card-body dashboardCard">
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-6">
                                <div class="">
                                    <!--
                                      WAR FALSCH: Hier stand vorher "Aktive Nutzer (heute)" mit
                                      einem Kommentar, der auf den (inzwischen ungenutzten)
                                      Tageswert aus fetchActiveUser verwies. Seit dem Fix des
                                      "steht den ganzen Tag auf 0"-Fehlers liest die Kachel über
                                      fetchActiveUsersToday() die Schnittstelle /user/active/1 —
                                      und die "1" bedeutet dort "die letzten 24 Stunden ab jetzt"
                                      (ETSBackend/helpers/utils.js, getDateToCheck), NICHT "seit
                                      Mitternacht". Die Beschriftung "(heute)" behauptete also ein
                                      Kalendertag-Fenster, das der Wert gar nicht hat, und konnte
                                      dem Diagramm direkt darunter (das echte Kalendertage zählt)
                                      widersprechen. Jetzt beschriftet die Kachel ehrlich das
                                      tatsächliche 24-Stunden-Fenster.
                                    -->
                                    <span class="fs-14">Aktive Nutzer (24 Std.)</span>
                                    <h2 class="mb-2 number-font carn1 font-weight-bold">{{displayNumber(activeUsers.sum)}}</h2>
                                </div>
                            </div>
                            <div class="headerChartContainer">
                                <div class="chart-wrapper">
                                    <LineChart :chartData="activeUsers.chartData" :options="activeUsers.chartOptions"/>
                                </div>
                            </div>
                        </div>
                        <!--
                          Erklärt, warum der heutige Tag in der Kurve fehlt.
                          Ohne diesen Satz stand oben eine live gezählte Zahl
                          („24 Std.") und darunter eine Kurve, die für heute 0
                          zeigte — zwei Angaben zur selben Sache, die sich
                          widersprachen (siehe fetchActiveUser). Der Hinweis
                          erscheint nur, wenn es tatsächlich etwas zu erklären
                          gibt; die ausführliche Fassung steht im title-Text.
                        -->
                        <span v-if="activeUsers.chartHint"
                              class="tile-footnote"
                              :title="activeUsers.chartHintDetail">{{ activeUsers.chartHint }}</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash3">
                    <div class="card-body dashboardCard">
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-6">
                                <div class="">
                                    <span class="fs-14">Betriebssysteme</span>
                                    <h2 class="mb-1 number-font carn1 font-weight-bold">{{displayNumber(userOS.amount)}}</h2>
                                </div>
                            </div>
                        </div>
                        <span class="fs-14 os-summary">{{userOS.summary}}</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash2">
                    <div class="card-body dashboardCard">
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-6">
                                <div class="">
                                    <span class="fs-14">Trips</span>
                                    <h2 class="mb-2 number-font carn1 font-weight-bold">{{displayNumber(amountOfTrips.amount)}}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="headerChartContainer">
                            <div class="chart-wrapper">
                                <LineChart :chartData="amountOfTrips.chartData" :options="amountOfTrips.chartOptions"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash4">
                    <div class="card-body dashboardCard">
                        <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <span class="fs-14 font-weight-normal">Neue Nutzer</span>
                                    <h2 class="mb-2 number-font carn1 font-weight-bold">{{displayNumber(registeredUsers.sum)}}</h2>
                                </div>
                        </div>
                                
                            <div class="chart-wrapper headerChartContainer">
                                <LineChart :chartData="registeredUsers.chartData" :options="registeredUsers.chartOptions"/>
                            </div>
                                
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="card overflow-hidden dash1-card border-0 dash1">
                    <div class="card-body dashboardCard">
                        <div class="row">
                                <div class="col-md-6 col-sm-6 col-6">
                                    <span class="fs-14 font-weight-normal">Gelöschte Nutzer</span>
                                    <h2 class="mb-2 number-font carn1 font-weight-bold">{{displayNumber(deletedUsers.sum)}}</h2>
                                </div>
                        </div>
                                
                                    <div class="chart-wrapper headerChartContainer">
                                        <LineChart :chartData="deletedUsers.chartData" :options="deletedUsers.chartOptions"/>
                                    </div>
                                
                    </div>
                </div>
            </div>
        </div>
        <!-- End Row-1 -->

        <!-- Neue Auswertungen (Ronny 2026-08-05) -->
        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Rangliste — Top 10</h3>
                    </div>
                    <div class="card-body pt-0">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nutzer</th>
                                        <th class="text-end">Punkte</th>
                                        <th class="text-end">km</th>
                                        <th class="text-end">Beiträge</th>
                                        <th class="text-end">Treffen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(user, i) in ranking" :key="user._id">
                                        <td class="align-middle">{{ i + 1 }}</td>
                                        <td class="align-middle">
                                            <img :src="`${$img(user.image,$awsSmallImages)}`" alt="" class="avatar avatar-sm brround me-2">
                                            {{ user.userName }}
                                        </td>
                                        <td class="align-middle text-end"><b>{{ user.points }}</b></td>
                                        <td class="align-middle text-end">{{ user.kilometers }}</td>
                                        <td class="align-middle text-end">{{ user.posts }}</td>
                                        <td class="align-middle text-end">{{ user.meetups }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Fahrzeuge — meistgenutzt</h3>
                        <div class="card-options">
                            <button class="btn btn-sm" :class="vehicleRankingTab === 'car' ? 'btn-primary' : 'btn-outline-primary'" @click="vehicleRankingTab = 'car'">Auto</button>
                            <button class="btn btn-sm" :class="vehicleRankingTab === 'bike' ? 'btn-primary' : 'btn-outline-primary'" @click="vehicleRankingTab = 'bike'">Motorrad</button>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Marke</th>
                                        <th>Modell</th>
                                        <th class="text-end">Anzahl</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, i) in vehicleRanking[vehicleRankingTab]" :key="row.make + row.model + i">
                                        <td class="align-middle">{{ row.make }}</td>
                                        <td class="align-middle">{{ row.model }}</td>
                                        <td class="align-middle text-end"><b>{{ row.count }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Auszeichnungen im Überblick</h3>
                    </div>
                    <div class="card-body pt-0">
                        <!--
                          WAR FALSCH: Hier stand die Liste der 25 zuletzt
                          VERLIEHENEN Auszeichnungen (awardedBadges,
                          /statistics/badges/awarded/25) — eine Einzelliste, kein
                          Überblick. Weil beim Anlegen alle Auszeichnungen eines
                          Nutzers im selben Moment entstehen, füllten 3-4 Nutzer
                          die ganze Karte, andere kamen gar nicht vor. Die
                          tatsächliche Überblicks-Abfrage (badgeOverview,
                          /statistics/badges: je Auszeichnung, wie viele Nutzer sie
                          haben) wurde zwar schon abgerufen, aber nirgends
                          angezeigt. Jetzt zeigt die Karte, was ihr Titel
                          verspricht: je Auszeichnung die Anzahl der Nutzer, die
                          sie erreicht haben, absteigend sortiert.
                        -->
                        <div class="table-responsive" style="max-height:340px;overflow-y:auto">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Auszeichnung</th>
                                        <th>Art</th>
                                        <th class="text-end">Nutzer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="badge in badgeOverviewSorted" :key="badge.key">
                                        <td class="align-middle">{{ badge.name }}</td>
                                        <td class="align-middle">{{ badgeKindLabel(badge.kind) }}</td>
                                        <td class="align-middle text-end"><b>{{ badge.users }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--
                          Fortsetzung der Umstellung oben: Die Bedingung hing an
                          "!awardedBadges.length" — an genau jener Liste, die mit der
                          Umstellung entfallen ist. Ohne diese Anpassung hätte sie ins
                          Leere gegriffen.
                          Sie fragt jetzt die Quelle ab, die die Karte tatsächlich
                          anzeigt: Hat mindestens eine Auszeichnung mindestens einen
                          Träger (badge.users > 0)? Auf den Katalog selbst darf man
                          dafür nicht prüfen — der ist immer gefüllt (25 Einträge),
                          auch wenn noch niemand etwas erreicht hat, und der Hinweis
                          "Bisher wurde keine Auszeichnung vergeben" käme dann nie.
                        -->
                        <!--
                          FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung sah
                          genauso aus wie "noch niemand hat eine Auszeichnung".
                          badgeOverviewError kommt aus fetchBadgeOverview() und
                          hat Vorrang vor der Leermeldung.
                        -->
                        <p v-if="badgeOverviewError" class="text-danger mb-0">{{ badgeOverviewError }}</p>
                        <p v-else-if="!badgeOverview.some(b => b.users > 0)" class="text-muted mb-0">Bisher wurde keine Auszeichnung vergeben.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Geworbene Nutzer</h3>
                    </div>
                    <div class="card-body pt-0">
                        <!--
                          FEHLER 5: Empfehlungsquote. War ohne Erfolgsprüfung —
                          eine Ablehnung zeigte kommentarlos "0 von 0 Nutzern...,
                          0 %". displayNumber() macht daraus "—" statt einer
                          erfundenen Null; referralsError ergänzt eine sichtbare
                          Meldung.
                        -->
                        <p class="mb-3">
                            <span class="h2 me-2">{{ displayNumber(referrals.recruited) }}</span>
                            von {{ displayNumber(referrals.total) }} Nutzern kamen über eine Empfehlung
                            <span class="badge bg-primary ms-2">{{ displayNumber(referrals.share) }} %</span>
                        </p>
                        <p v-if="referralsError" class="text-danger mb-0">{{ referralsError }}</p>
                        <!--
                          Dieselbe Umstellung für die Werberliste: recruitedError
                          hat Vorrang vor "Bisher wurde niemand...", sonst wäre
                          eine Ablehnung nicht von echter Leere zu unterscheiden.
                        -->
                        <div class="table-responsive" style="max-height:300px;overflow-y:auto" v-if="recruitedError">
                            <p class="text-danger mb-0">{{ recruitedError }}</p>
                        </div>
                        <div class="table-responsive" style="max-height:300px;overflow-y:auto" v-else-if="recruited.length === 0">
                            <p class="text-muted mb-0">Bisher wurde niemand über einen Werbecode geworben.</p>
                        </div>
                        <div class="table-responsive" style="max-height:300px;overflow-y:auto" v-else>
                            <table class="table table-hover">
                                <thead>
                                    <tr><th>Werber</th><th>geworben</th></tr>
                                </thead>
                                <tbody>
                                    <tr v-for="r in recruited" :key="r._id">
                                        <td class="align-middle">
                                            <img :src="`${$img(r.referrerImage,$awsSmallImages)}`" alt="" class="avatar avatar-sm brround me-2">
                                            {{ r.referrerName }}
                                            <span class="text-muted">({{ r.referrerTotal }})</span>
                                        </td>
                                        <td class="align-middle">
                                            <img :src="`${$img(r.image,$awsSmallImages)}`" alt="" class="avatar avatar-sm brround me-2">
                                            {{ r.userName }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Meldungen</h3>
                        <div class="card-options">
                            <a class="btn btn-sm btn-primary" @click="$router.push('reported')">Alle ansehen</a>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <!--
                          FEHLER 1 (schwerster, siehe Auftrag): Vorher stand hier
                          v-if="reports.length" / v-else "Keine Meldungen vorhanden.".
                          Diese Bedingung trifft auf "wirklich leer" und auf "Abruf
                          abgelehnt" gleichermaßen zu — der Verwalter sah bei einer
                          fachlichen Ablehnung (HTTP 200, success:false) exakt die
                          Meldung, die eigentlich "hier gibt es nichts zu tun"
                          bedeutet, ausgerechnet auf der Liste, die Missbrauch
                          sichtbar macht. Jetzt drei Zustände: lädt · Abruf
                          gescheitert · wirklich leer · Ergebnisse (gleiche Kette
                          wie in Users.vue/Reported.vue).
                        -->
                        <div class="table-responsive" style="max-height:340px;overflow-y:auto" v-if="reportsLoading && reports.length === 0">
                            <p class="text-muted mb-0">Wird geladen …</p>
                        </div>
                        <div class="table-responsive" style="max-height:340px;overflow-y:auto" v-else-if="reportsError">
                            <p class="text-danger mb-0">{{ reportsError }}</p>
                        </div>
                        <div class="table-responsive" style="max-height:340px;overflow-y:auto" v-else-if="reports.length === 0">
                            <p class="text-muted mb-0">Keine Meldungen vorhanden.</p>
                        </div>
                        <div class="table-responsive" style="max-height:340px;overflow-y:auto" v-else>
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Gemeldet</th>
                                        <th>Problem</th>
                                        <th>Art</th>
                                        <th>von</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="report in reports" :key="report._id">
                                        <td class="align-middle">
                                            <img :src="`${$img(report.reportedImage,$awsSmallImages)}`" alt="" class="avatar avatar-sm brround me-2">
                                            {{ report.reportedName || '—' }}
                                        </td>
                                        <td class="align-middle tableAbout">
                                            {{ report.reason || 'kein Grund angegeben' }}
                                            <div v-if="report.postDescription" class="text-muted" style="font-size:11px">
                                                „{{ report.postDescription }}"
                                            </div>
                                        </td>
                                        <td class="align-middle">{{ reportTypeLabel(report.type) }}</td>
                                        <td class="align-middle">{{ report.reporterName || '—' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Beiträge und Kommentare</h3>
                    </div>
                    <div class="card-body pt-0">
                        <div class="chart-wrapper">
                            <LineChart :chartData="activity.chartData" :options="activity.chartOptions"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Verwendete App-Versionen</h3>
                    </div>
                    <div class="card-body pt-0">
                        <!--
                          Ohne installedVersions.result stand hier nur eine leere
                          weisse Flaeche unter der Ueberschrift — nicht zu
                          unterscheiden von "kaputt". Andere Karten der Seite
                          (z. B. "Auszeichnungen im Ueberblick") haben dafuer
                          einen Hinweistext, dieses Diagramm hatte keinen.
                        -->
                        <!--
                          FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung
                          zeigte "Noch keine App-Version erfasst.", obwohl der
                          Abruf gar nicht erst geklappt hat. installedVersionsError
                          kommt aus fetchInstalledVersions() und geht vor.
                        -->
                        <p v-if="installedVersionsError" class="text-danger mb-0">{{ installedVersionsError }}</p>
                        <div class="chart-wrapper" v-else-if="installedVersions.result.length">
                            <BarChart v-bind:chartData="installedVersions.chartData" :options="installedVersions.chartOptions"/>
                        </div>
                        <p v-else class="text-muted mb-0">Noch keine App-Version erfasst.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Row-3 -->
        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header border-bottom-0">
                        <h3 class="card-title">Meist gefahrene Kilometer </h3>
                    </div>
                    <div class="card-body pt-0">
                        <div class="chart-wrapper">
                            <BarChart v-bind:chartData="topUsersByDistance.chartData" :options="topUsersByDistance.chartOptions"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">
                            Höchste Anzahl an Beiträgen
                        </h3>
                        <div class="card-options">
                            <!-- Führte auf die eingelösten Belohnungen statt auf die Beiträge -->
                            <a class="btn btn-sm btn-primary" @click="$router.push('posts')">Alle ansehen</a>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="card-body pt-0">
                        <div class="chart-wrapper">
                            <BarChart v-bind:chartData="topUsersByPost.chartData" :options="topUsersByPost.chartOptions"/>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Row-3 -->    

        <!-- Row-4 -->
        <div class="row row-deck">
            <div class="col-lg">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">
                            Letzte Beiträge
                        </h3>
                        <div class="card-options">
                            <a @click="$router.push('posts')" class="btn btn-sm btn-primary">Alle ansehen</a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive table-hover clickable">
                            <table class="table card-table table-vcenter text-nowrap">
                                <thead>
                                    <th>Benutzername</th>
                                    <th>Bild</th>
                                    <th>Beschreibung</th>
                                    <th>Veröffentlichung</th>
                                </thead>
                                <tbody>
                                    <tr v-for="post in lastPosts" :key="post._id" @click="clickOnTableRow('Posts', { post: post })">
                                    <!-- Beitrag ohne Bild oder von einem gelöschten Nutzer ließ
                                         die Startseite weiß werden -->
                                    <td class="align-middle">{{ post.user ? post.user.userName : 'Unbekannt' }}</td>
                                    <td>
                                        <img :src="`${$img(firstImage(post), $awsLargeImages)}`" alt="" class="avatar avatar-md brround ">
                                    </td>
                                    <td class="align-middle tableAbout">{{ post.description }}</td>
                                    <td class="align-middle">{{ $formatDate(post.createdAt) }}</td>
                                    
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

        <!-- Belohnungen sind abgeschaltet (ENTS-8, Ronny 2026-08-05).
             Box bleibt erhalten, falls sie zurückkehren soll — dann diesen
             Kommentar entfernen und den Abruf in fetchData wieder aktivieren. -->
        <!--
        <div class="row row-deck">
            <div class="col-lg">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">
                            Letzte freigeschaltete Belohnungen
                        </h3>
                        <div class="card-options">
                            <a @click="$router.push('rewardHistory')" class="btn btn-sm btn-primary">Alle ansehen</a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive table-hover">
                            <table class="table card-table table-vcenter text-nowrap">
                                <thead>
                                    <th>Titel</th>
                                    <th>Kategorie</th>
                                    <th>Benutzername</th>
                                    <th>Typ</th>
                                    <th>Coins</th>
                                    <th>Adresse</th>
                                    <th>E-Mail</th>
                                    <th>Aktion</th>
                                </thead>
                                <tbody>
                                    <tr v-for="rewardObject in lastRewards.result" :key="rewardObject._id">
                                    <td class="align-middle">{{ rewardObject.reward == null ? '' : rewardObject.reward.title }}</td>
                                    <td class="align-middle">{{ rewardObject.reward == null ? '' : rewardObject.reward.category }}</td>
                                    <td class="align-middle">{{ rewardObject.userName == null ? '' : rewardObject.userName }}</td>
                                    <td class="align-middle">
                                        <div v-if="rewardObject.reward != null && rewardObject.reward.type=='address'"> Adresse</div>
                                        <div v-if="rewardObject.reward != null && rewardObject.reward.type=='email'"> E-Mail</div>
                                    </td>
                                    <td class="align-middle">{{ rewardObject.reward == null ? '' : rewardObject.reward.coins }}</td>
                                    <td class="align-middle"> {{ rewardObject.address == null ? '' :rewardObject.address }} </td>
                                    <td class="align-middle">{{ rewardObject.email == null ? '' : rewardObject.email }}</td>
                                    <td>
                                    <a
                                        class="btn btn-primary btn-small mr-1"
                                        @click="sendReward(rewardObject)"
                                        ><i class="fas fa-paper-plane"></i></a>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        -->
  </div>
</template>

<script>

import BarChart from './charts/Bar.vue'
import LineChart from './charts/Line.vue'
import PieChart from './charts/Pie.vue'

// Optionen für die kleinen Statistiken in den Kopf-Kacheln: keine Legende,
// keine Achsen, keine Tooltips — die Grafik deutet den Verlauf nur an und
// läuft von links nach rechts. Höhe und Platzierung regelt das CSS.
// Die kleinen Statistiken in den Kacheln zeigen immer die letzten 30 Tage,
// unabhängig vom Datumsfilter oben (Ronny 2026-08-05).
const TILE_DAYS = 30;

const TILE_CHART_OPTIONS = {
    legend: { display: false },
    tooltips: { enabled: false },
    maintainAspectRatio: false,
    responsive: true,
    layout: { padding: 0 },
    elements: {
        point: { radius: 0 },
        line: { borderWidth: 2, tension: 0.4, fill: true },
    },
    scales: {
        yAxes: [{ display: false, gridLines: { display: false }, ticks: { beginAtZero: true } }],
        xAxes: [{
            display: false,
            gridLines: { display: false },
            // schmale Balken mit Luft dazwischen — sonst wirken wenige Werte
            // wie ein massiver Block statt wie eine Statistik
            barPercentage: 0.45,
            categoryPercentage: 0.7,
        }],
    },
}



export default {
    name: 'Dashboard',
   components: {
    BarChart,
    LineChart,
    PieChart,
   },


   data() {
       return {

           chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartOptions: {
        responsive: true
      },
        // sum, result und chartStyle werden erst beim Laden zugewiesen. Vue 2
        // macht nachträglich angelegte Eigenschaften nicht reaktiv — die
        // Kachel blieb dadurch leer, obwohl die Zahl ankam. Deshalb hier
        // vollständig deklarieren.
        registeredUsers: {
            chartData: {},
            result: [],
            // FEHLER 5: null statt 0 — displayNumber() zeigt dafür "—", damit
            // eine fehlgeschlagene Abfrage nicht wie eine echte Null aussieht.
            sum: null,
            chartStyle: {},
            chartOptions: {},
        },
        // result gehört hier deklariert, nicht erst in fetchInstalledVersions()
        // zugewiesen: Vue 2 macht nachträglich angelegte Eigenschaften nicht
        // reaktiv. Ohne result: [] hier hätte der neue v-if darauf beim ersten
        // Rendern auf undefined.length zugegriffen und die Karte wäre stumm
        // leer geblieben, auch wenn Daten kamen.
        installedVersions: {
            chartData: {},
            chartOptions: {},
            result: [],
        },
        installedVersionsError: '',
        // chartHint/chartHintDetail gehören hier deklariert und nicht erst in
        // fetchActiveUser() zugewiesen: Vue 2 macht nachträglich angelegte
        // Eigenschaften nicht reaktiv — der Hinweis unter der Zahl erschiene
        // sonst erst beim nächsten Neuzeichnen aus anderem Anlass, also
        // praktisch nie.
        activeUsers: {
            chartData: {},
            result: [],
            sum: null,
            chartOptions: {},
            chartHint: '',
            chartHintDetail: '',
        },
        topUsersByDistance: {
            chartData: {},
            chartOptions: {},
        },
        topUsersByPost: {
            chartData: {},
            chartOptions: {},
        },
        // amount, summary und result gehören hier deklariert: Vue 2 macht
        // Eigenschaften, die erst später zugewiesen werden, nicht reaktiv —
        // die Kachel blieb dann leer, obwohl die Zahlen ankamen.
        userOS: {
            chartData: {},
            result: [],
            amount: null,
            summary: '',
        },
        deletedUsers: {
            chartData: {},
            result: [],
            sum: null,
            chartOptions: {},
        },
        lastPosts: [],
        lastRewards: [],
        userAmount: {
            amount: null,
            chartData: {},
            chartOptions: {},
        },
        ranking: [],
        vehicleRanking: { car: [], bike: [] },
        vehicleRankingTab: 'car',
        badgeOverview: [],
        badgeOverviewError: '',
        recruited: [],
        recruitedError: '',
        reports: [],
        // Trennt "lädt gerade" von "wirklich leer" von "Abruf gescheitert" —
        // siehe fetchReports() und die Zustandskette im Template (FEHLER 1).
        reportsLoading: false,
        reportsError: '',
        // total/recruited/share starten auf null, nicht 0 — displayNumber()
        // zeigt dafür "—", solange fetchReferrals() noch nicht erfolgreich war.
        referrals: { total: null, recruited: null, share: null, topReferrers: [] },
        referralsError: '',
        activity: { chartData: {}, chartOptions: {} },
        amountOfTrips: {
            amount: null,
            chartData: {},
            chartOptions: {},
        },

        
        currentTimeSpan: 'AllTime', // ENTS-7: Standard auf „Gesamt"
           
       }
   },

   mounted() {
       let _this = this;
       
       this.fetchData(this.currentTimeSpan);
   },

   computed: {
       // Absteigend nach Nutzerzahl, damit die am meisten erreichten
       // Auszeichnungen oben stehen — badgeOverview selbst kommt unsortiert
       // vom Server (siehe ETSBackend/controllers/v1/statisticsController.js).
       badgeOverviewSorted() {
           return [...this.badgeOverview].sort((a, b) => (b.users || 0) - (a.users || 0));
       },
   },

   watch: {
       registeredUsers: {
           handler() {
               if(this.registeredUsers.length > 0){
               }
           }
       }, 
       installedVersions: {
           handler() {
               
           }
       },
   },

   methods: {
       /**
        * Erstes Bild eines Beitrags — mit Absicherung.
        *
        * Das Modell erlaubt Beiträge ohne Bild; der direkte Zugriff auf das
        * erste Element ließ dann die ganze Startseite weiß werden.
        */
       firstImage(post) {
           if (!post || !post.galleryImages || post.galleryImages.length === 0) return '';
           return post.galleryImages[0].url;
       },

       /**
        * FEHLER 5: Zeigt "—" statt einer erfundenen 0, solange der zugehörige
        * Wert nicht erfolgreich geladen wurde (null). Der Verwalter muss eine
        * echte Null von einer fehlgeschlagenen Abfrage unterscheiden können.
        */
       displayNumber(value) {
           return (value === null || value === undefined) ? '—' : value;
       },

       /**
        * WAR FALSCH: Fehlte komplett. Jeder Fehlschlag lief nur in die
        * Entwicklerkonsole, die niemand offen hat — eine Kachel, die nicht
        * laden konnte, sah exakt so aus wie eine, die eine echte 0 zeigt.
        * Zwei Formen kommen vor: Axios-Fehler (Netz/HTTP) und der
        * Antwortkörper eines fachlichen Fehlschlags ({success:false,
        * message:"…"} mit HTTP 200), den die Aufrufer unten direkt
        * hereinreichen. Gleiches Muster wie in Users.vue/Models.vue.
        */
       onError(err) {
           if (err != null && err.response != null && err.response.data != null) {
               console.error(err.response.data);
           } else {
               console.error(err);
           }
           const status = err != null && err.response != null ? err.response.status : null;
           if (status === 401 || status === 403) return;
           this.$noty.error(this.failureMessage(err) || 'Eine Kachel konnte nicht geladen werden.');
       },
       // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
       // sonst null. Gleiches Muster wie in Users.vue/Reported.vue.
       failureMessage(err) {
           if (err == null) return null;
           if (err.response != null && err.response.data != null && err.response.data.message) {
               return err.response.data.message;
           }
           if (err.response == null && err.success === false && err.message) {
               return err.message;
           }
           return null;
       },

       fetchData(timeSpan) {
           let _this = this;
           let time = -1;
           this.setTimePicker(timeSpan);

           if(timeSpan == 'Today') {
               time = 1;
           } else if (timeSpan == 'LastWeek') {
               time = 7;
           } else if (timeSpan == 'LastMonth') {
               time = 30;
           } else if (timeSpan == 'AllTime') {
               time = -1;
           }

           // War fest auf TILE_DAYS (30 Tage) verdrahtet: Bei Filter "Letzte
           // 24 Stunden" zeigten "Neue Nutzer", "Gelöschte Nutzer" und
           // "Trips" trotzdem weiter die 30-Tage- bzw. Gesamtzahl, während
           // "Betriebssysteme" (fetchSystemInformation(time)) und "Aktive
           // Nutzer" (fetchActiveUser(time)) korrekt auf den gewählten
           // Zeitraum reagierten. Jetzt bekommen alle Kacheln denselben `time`.
           this.fetchRegisteredUsers(time);
           this.fetchTripsByDate(time);
           this.fetchRanking();
           this.fetchVehicleRanking();
           this.fetchBadgeOverview();
           this.fetchReferrals();
           this.fetchRecruited();
           this.fetchReports();
           this.fetchActivity(TILE_DAYS);
           this.fetchActiveUser(time);
           this.fetchActiveUsersToday();
           this.fetchInstalledVersions();
           this.fetchSystemInformation(time);
           this.fetchTopUserByPost(time);
           this.fetchTopUserByDistance(time);
           this.fetchLastPosts();
           // this.fetchLastRewards(time);   // ENTS-8: Belohnungen abgeschaltet
       },
       fetchRegisteredUsers(time) {
           let _this = this;

           this.$axios.get('/user/registered/date/' + time).then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung liess
               // "Neue Nutzer" und "Gelöschte Nutzer" einfach beim zuletzt
               // geladenen Wert stehen, ohne jede Meldung.
               if (response.data == null || response.data.success === false) {
                   _this.registeredUsers.sum = null;
                   _this.deletedUsers.sum = null;
                   _this.onError(response.data);
                   return;
               }
               _this.registeredUsers.result = response.data.data;
               let reg = new RegExp('[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]');
               const tempArr = _this.registeredUsers.result.filter(m => reg.test(m.validFor));


               const counts = tempArr.map(m => m.numberOfRegisteredUsers + m.numberOfRegisteredAnonymousUsers);
               const deleteCounts = tempArr.map(m => m.numberOfDeletedUsers + m.numberOfDeletedAnonymousUsers);
               const times = tempArr.map(m => _this.currentTimeSpan == 'AllTime' ? m.validFor : m.validFor.split('-')[2] + '-' + m.validFor.split('-')[1]);

               _this.registeredUsers.sum = counts.reduce((pv, cv) => pv + cv, 0);
               _this.deletedUsers.sum = deleteCounts.reduce((pv, cv) => pv + cv, 0);

               // Gesamte Nutzer als Wachstumskurve: laufende Summe der
               // Tageswerte, rückwärts an den heutigen Bestand angeglichen.
               let runningTotal = 0;
               const growth = counts.map((c, i) => (runningTotal += c - deleteCounts[i]));
               const currentCount = _this.userAmount.amount || growth[growth.length - 1] || 0;
               const offset = currentCount - (growth[growth.length - 1] || 0);
               _this.userAmount.chartData = {
                   labels: times,
                   datasets: [{
                       data: growth.map(w => w + offset),
                       backgroundColor: 'rgba(223, 217, 245, 0.3)',
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               };
               _this.userAmount.chartOptions = TILE_CHART_OPTIONS;

               _this.registeredUsers.chartData = {
                   labels: times,
                   datasets: [{
                       label: 'Anzahl der registrierten Nutzer',
                       data: counts,
                       backgroundColor: 'rgba(223, 217, 245, 0.3)',
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.registeredUsers.chartOptions = TILE_CHART_OPTIONS;

                _this.deletedUsers.chartData = {
                   labels: times,
                   datasets: [{
                       label: 'Anzahl der gelöschten Nutzer',
                       data: deleteCounts,
                       backgroundColor: 'rgba(223, 217, 245, 0.3)',
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.deletedUsers.chartOptions = TILE_CHART_OPTIONS;
                _this.registeredUsers.chartStyle = {
                    
                }
           }).catch(function(error) {
               _this.registeredUsers.sum = null;
               _this.deletedUsers.sum = null;
               _this.onError(error);
           });
           this.$axios.get('/home/dashboard').then(function(response) {
            // Gleiche Absicherung: "Gesamte Nutzer" behielt bisher bei einer
            // Ablehnung stillschweigend den alten Wert.
            if (response.data == null || response.data.success === false) {
                _this.userAmount.amount = null;
                _this.onError(response.data);
                return;
            }
            _this.userAmount.amount = response.data.data.users;
            // chartData kommt aus fetchRegisteredUsers (Wachstumskurve) — hier
            // nur die Aufteilung anonym/normal für spätere Verwendung.
            _this.userAmount.split = {
                   labels: ["Anonyme Nutzer", "Normale Nutzer"],
                   datasets: [{
                       data: [response.data.data.anonymousUserAmount, response.data.data.notAnonymousUserAmount],
                       backgroundColor: '#664dc9',
                       backgroundColor: ['rgba(223, 217, 245, 0.3)', 'rgba(223, 217, 245, 0.6)'],
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.userAmount.chartOptions = TILE_CHART_OPTIONS;

            const tripByCategory = response.data.data.tripByCategory;
            const counts = tripByCategory.map(trip => trip.count);
            const labels = tripByCategory.map(trip => trip._id == "1 point" ? "1 Punkt" : trip._id == "2 point" ? "2 Punkte" : "Custom");
            // amountOfTrips.amount NICHT mehr von hier setzen: /home/dashboard
            // liefert immer die ungefilterte Gesamtzahl. Der Kachelwert kommt
            // jetzt aus fetchTripsByDate(time) (siehe dort) und reagiert damit
            // auf den gewählten Zeitraum. Hier nur noch die Aufteilung nach
            // Kategorie fürs Kreisdiagramm.
            // chartData kommt aus fetchTripsByDate (Zeitreihe) — hier nur die Summe.
            _this.amountOfTrips.categories = {
                   labels: labels,
                   datasets: [{
                       data: counts,
                       backgroundColor: '#664dc9',
                       backgroundColor: ['rgba(223, 217, 245, 0.3)', 'rgba(223, 217, 245, 0.6)'],
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.amountOfTrips.chartOptions = TILE_CHART_OPTIONS;
           }).catch(function(error){
            _this.userAmount.amount = null;
            _this.onError(error);
           })
       },
        /**
         * Führt einen Wert aus dem Feld validFor auf einen Kalendertag in der
         * Form JJJJ-MM-TT zurück.
         *
         * Die Statistikzeilen kommen in zwei Schreibweisen aus dem Backend:
         * sauber („2026-08-14") und unbrauchbar („Fri Aug 14 2026 04:00:00
         * GMT+0200 (…)", siehe Kommentar in fetchActiveUser). Beide meinen
         * denselben Tag — deshalb wird die zweite Form hier gedeutet statt
         * weggeworfen. Nur was sich überhaupt nicht als Datum lesen lässt
         * (leeres Feld, Unsinn), ergibt null und fällt aus dem Diagramm.
         *
         * Bewusst über die ÖRTLICHEN Datumsanteile und nicht über
         * toISOString(): Der 4-Uhr-Auftrag meint den örtlichen Kalendertag;
         * eine Umrechnung nach UTC könnte je nach Zeitzone einen Tag daneben
         * liegen.
         */
        toDayLabel(validFor) {
            const raw = String(validFor == null ? '' : validFor).trim();
            const alreadyClean = raw.match(/^(\d{4}-\d{2}-\d{2})/);
            if (alreadyClean) return alreadyClean[1];
            // Ohne vierstellige Jahreszahl gar nicht erst raten: new Date('5')
            // liefert ein gültiges, aber frei erfundenes Datum.
            if (!/\d{4}/.test(raw)) return null;
            const parsed = new Date(raw);
            if (isNaN(parsed.getTime())) return null;
            const pad = n => (n < 10 ? '0' + n : String(n));
            return parsed.getFullYear() + '-' + pad(parsed.getMonth() + 1) + '-' + pad(parsed.getDate());
        },
        /**
         * Der heutige Kalendertag in der Form JJJJ-MM-TT.
         *
         * Bewusst aus den ÖRTLICHEN Datumsanteilen zusammengesetzt und nicht
         * über toISOString(): Der nächtliche Auftrag meint den örtlichen
         * Kalendertag. In Deutschland läge toISOString() abends um 23:00 Uhr
         * bereits einen Tag weiter — die Kurve würde dann den falschen Tag
         * ausblenden.
         */
        currentDayLabel() {
            const now = new Date();
            const pad = n => (n < 10 ? '0' + n : String(n));
            return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
        },
        fetchActiveUser(time) {
            let _this = this;
            this.$axios.get('/user/active/amount/' + time).then(function (response) {
                // FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung liess die
                // Kurve einfach beim zuletzt geladenen Verlauf stehen.
                if (response.data == null || response.data.success === false) {
                    _this.onError(response.data);
                    return;
                }
                _this.activeUsers.result = response.data.data || [];

               // WAR FALSCH (Stufe 1): Die Beschriftungen wurden mit einem
               // Datumsmuster gefiltert, die zugehörigen Messwerte dagegen
               // ungefiltert aus derselben Antwort genommen:
               //     counts = result.map(...)                   // ALLE Zeilen
               //     times  = result.filter(reg).map(...)       // nur saubere
               // Beide Listen konnten damit unterschiedlich lang sein. Chart.js
               // paart Beschriftung und Wert stumpf nach Position — dadurch
               // rutschte jeder Wert nach der herausgefilterten Zeile unter das
               // falsche Datum, und der letzte Wert fiel ganz aus dem Diagramm.
               //
               // WAR FALSCH (Stufe 2, der eigentliche Punkt): Der erste
               // Reparaturversuch hat zwar gemeinsam gefiltert — dabei aber die
               // unbrauchbare Zeile WEGGEWORFEN. Damit verschwand der betroffene
               // Tag stillschweigend aus der Kurve, und zwar regelmäßig der
               // heutige: Er ist tagsüber der einzige, für den nur die kaputte
               // Zeile existiert. Der Verwalter sah eine Kurve, die einen Tag zu
               // früh endet, ohne jeden Hinweis darauf.
               //
               // WOHER die kaputten Zeilen kommen: Der 4-Uhr-Auftrag legt für
               // den neuen Tag eine leere Statistikzeile an. Er bringt das Datum
               // zwar in die Form JJJJ-MM-TT, übernimmt das Ergebnis aber nicht
               // (ETSBackend/jobs/dailyJob.js, createUserStatisticDocument).
               // Gespeichert wird das ganze Datumsobjekt, als Zeichenkette also
               // „Fri Aug 14 2026 04:00:00 GMT+0200 (…)". Diese Zeile trägt
               // immer numberOfActiveUsers = 0 (Vorgabewert des Datenmodells);
               // die echte Zahl schreibt der 23:55-Auftrag in eine ZWEITE Zeile
               // mit sauberem Datum. Für denselben Tag können also zwei Zeilen
               // nebeneinander stehen. Die Ursache gehört ins Backend — das
               // Diagramm muss aber auch mit dem heutigen Datenbestand richtig
               // sein.
               //
               // Deshalb jetzt in drei Schritten, statt etwas wegzuwerfen:
               //   1. Jede Zeile auf einen Kalendertag zurückführen
               //      (toDayLabel deutet auch die kaputte Schreibweise).
               //   2. Zeilen desselben Tages zusammenführen und dabei den
               //      höheren Wert behalten — die 4-Uhr-Zeile mit ihrer 0 darf
               //      die echte Zahl nicht überschreiben.
               //   3. Nach Datum sortieren: Das Backend liefert ohne $sort
               //      (userController.getActiveUserAmount nutzt find() ohne
               //      Sortierung), und die kaputten Zeilen sortieren als Text
               //      ohnehin hinter die sauberen.
               const highestPerDay = {};
               _this.activeUsers.result.forEach(function (row) {
                   const day = _this.toDayLabel(row.validFor);
                   if (day === null) return;
                   const value = Number(row.numberOfActiveUsers) || 0;
                   if (highestPerDay[day] === undefined || value > highestPerDay[day]) {
                       highestPerDay[day] = value;
                   }
               });
               const allDays = Object.keys(highestPerDay).sort();

               // WAR FALSCH: Hier ging auch der LAUFENDE Kalendertag in die
               // Kurve — mit einem Wert, den noch niemand gemessen hat.
               //
               // Was ein Mensch merkte: In derselben Kachel stand oben
               // „Aktive Nutzer (24 Std.): 7" und die Kurve direkt darunter
               // endete für heute auf 0. Zwei Zahlen zum selben Thema,
               // nebeneinander, die sich widersprechen — der Verwalter konnte
               // nicht wissen, welche stimmt.
               //
               // Warum: Die Zahl oben wird live aus der Nutzer-Sammlung
               // gezählt (fetchActiveUsersToday). Die Kurve kommt aus der
               // Tagesstatistik, und dort wird der Wert für den laufenden Tag
               // erst um 23:55 Uhr eingetragen (ETSBackend/jobs/dailyJob.js,
               // saveActiveUsers, Zeitplan '55 23 * * *'). Bis dahin steht in
               // der heutigen Zeile der Vorgabewert 0 — sie wird nämlich schon
               // beim ersten Ereignis des Tages angelegt. Der Widerspruch
               // bestand damit jeden Tag von Mitternacht bis 23:55 Uhr, also
               // praktisch immer, wenn jemand hinsieht.
               //
               // Die 0 ist keine Messung, sondern ein Platzhalter. Deshalb
               // wird der laufende Tag gar nicht erst gezeichnet, und darunter
               // steht sichtbar, warum — stillschweigend weglassen wäre genau
               // der Fehler, der bei der vorigen Reparatur schon einmal
               // gemacht wurde (Kurve endete einen Tag zu früh, ohne Hinweis).
               //
               // Bewusst nicht gelöst durch „heutigen Wert aus /user/active/1
               // einsetzen": Das ist ein rollendes 24-Stunden-Fenster, die
               // Kurve zählt Kalendertage seit Mitternacht. Beides in eine
               // Linie zu mischen wäre ein neuer, schwerer zu erkennender
               // Fehler.
               const today = _this.currentDayLabel();
               const times = allDays.filter(day => day !== today);
               const counts = times.map(day => highestPerDay[day]);

               if (times.length === 0) {
                   _this.activeUsers.chartHint = 'Kurve: noch kein abgeschlossener Tag erfasst';
                   _this.activeUsers.chartHintDetail = 'Die Tagesstatistik wird erst um 23:55 Uhr für den ablaufenden Tag geschrieben. Für den gewählten Zeitraum liegt noch kein abgeschlossener Tag vor. Die Zahl oben zählt unabhängig davon live die letzten 24 Stunden.';
               } else if (times.length !== allDays.length) {
                   _this.activeUsers.chartHint = 'Kurve: abgeschlossene Tage · heute folgt 23:55';
                   _this.activeUsers.chartHintDetail = 'Der heutige Tag steht noch nicht in der Kurve: Die Tagesstatistik wird erst um 23:55 Uhr geschrieben, bis dahin stünde dort ein Platzhalter (0). Die Zahl oben zählt dagegen live die letzten 24 Stunden.';
               } else {
                   _this.activeUsers.chartHint = '';
                   _this.activeUsers.chartHintDetail = '';
               }

               // Der Kachelwert (activeUsers.sum) kommt NICHT mehr von hier,
               // siehe fetchActiveUsersToday(). Diese Antwort liefert nur noch
               // den Verlauf fürs Diagramm darunter.
               _this.activeUsers.chartData = {
                   labels: times,
                   datasets: [{
                       label: 'Anzahl der aktiven Nutzer',
                       data: counts,
                       backgroundColor: 'rgba(223, 217, 245, 0.3)',
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.activeUsers.chartOptions = TILE_CHART_OPTIONS;
                _this.activeUsers.chartStyle = {
                    height: '250px',
                }
            }).catch(_this.onError);
        },
        /**
         * Tatsächliche Anzahl der gerade aktiven Nutzer — direkt aus der
         * Nutzer-Sammlung, nicht aus der Tagesstatistik.
         *
         * WAR FALSCH: Die Kachel „Aktive Nutzer (heute)" las bisher den
         * ZULETZT erfassten Tageswert aus /user/active/amount (siehe
         * fetchActiveUser oben). Diese Statistikzeile wird beim ersten Login
         * des Tages mit 0 angelegt und erst um 23:55 Uhr vom nächtlichen
         * Auftrag mit der echten Zahl überschrieben (ETSBackend/jobs/dailyJob.js,
         * saveActiveUsers). Den ganzen Tag über stand die Kachel deshalb auf 0,
         * obwohl Leute in der App unterwegs waren.
         *
         * GET /user/active/1 fragt dagegen live in der Nutzer-Sammlung nach,
         * wer in den letzten 24 Stunden aktiv war (lastActive) — ganz ohne
         * Umweg über den nächtlichen Auftrag.
         */
        fetchActiveUsersToday() {
            let _this = this;
            // BEKANNTE GRENZE: /user/active/1 liefert eine Zeile JE aktivem
            // Nutzer, gebraucht wird davon nur die Anzahl. Bei 7 aktiven
            // Nutzern sind das rund 580 Byte — die Menge wächst aber mit der
            // Nutzerzahl, und die Abfrage läuft bei jedem Aufruf der Startseite
            // und bei jedem Wechsel des Zeitraums.
            // Bewusst so belassen: Die Alternative wäre ein neuer Endpunkt im
            // Backend, der nur zählt. Das gehört in ein eigenes Arbeitspaket —
            // hier ginge es auf Kosten der Kachel, die vorher dauerhaft 0
            // anzeigte. Wer den Bestand wachsen sieht, sollte zuerst hier
            // nachbessern.
            this.$axios.get('/user/active/1').then(function (response) {
                // WAR FALSCH (FEHLER 5): Lehnte der Server ab (HTTP 200,
                // success:false), fehlt data — Array.isArray(undefined) ist
                // false, der Rückfall auf 0 zeigte dann eine erfundene echte
                // Null statt "hier konnte nichts geladen werden". Jetzt
                // unterscheidet null (nicht geladen) von 0 (wirklich niemand
                // aktiv).
                if (response.data == null || response.data.success === false) {
                    _this.activeUsers.sum = null;
                    _this.onError(response.data);
                    return;
                }
                // Array.isArray statt "|| []": Käme statt der Liste ein Objekt
                // zurück, wäre .length undefined und die Kachel bliebe leer,
                // ohne dass irgendwo etwas auffiele.
                const rows = response.data.data;
                _this.activeUsers.sum = Array.isArray(rows) ? rows.length : 0;
            }).catch(function (error) {
                _this.activeUsers.sum = null;
                _this.onError(error);
            });
        },
       fetchInstalledVersions() {
           let _this = this;

           this.$axios.get('/user/versions').then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung sah
               // vorher exakt aus wie "noch keine App-Version erfasst".
               // installedVersionsError geht im Template davor.
               if (response.data == null || response.data.success === false) {
                   _this.installedVersionsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                   _this.onError(response.data);
                   return;
               }
               _this.installedVersionsError = '';
               // "|| []" ist hier nicht Zierde: Seit die Karte per v-if auf
               // installedVersions.result.length prüft, würde eine leere
               // Antwort (null) beim Rendern auf undefined.length zugreifen und
               // die ganze Startseite abbrechen lassen.
               _this.installedVersions.result = response.data.data || [];
               const count = _this.installedVersions.result.map(m => m.count);
               const labels = _this.installedVersions.result.map(m => m._id);

               _this.installedVersions.chartData = {
                   labels: labels,
                   datasets: [{
                       label: 'Anzahl der Benutzer pro Version',
                       data: count,
                       backgroundColor: '#664dc9',
                   }]
               }
               _this.installedVersions.chartOptions = {
                   scales: {
                       yAxes: [{
                           ticks: {
                                min: 0,
                                reverse: false,
                            },
                       }]
                   },
                }

           }).catch(function(error) {
               _this.installedVersionsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
               _this.onError(error);
           });
       },
       fetchSystemInformation(time) {
           let _this = this;

           this.$axios.get('/user/os/amount/' + time).then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — "Betriebssysteme" behielt
               // bei einer Ablehnung stillschweigend den alten Wert.
               if (response.data == null || response.data.success === false) {
                   _this.userOS.amount = null;
                   _this.onError(response.data);
                   return;
               }
               _this.userOS.result = response.data.data;
               const count = _this.userOS.result.map(m => m.count);
               const labels = _this.userOS.result.map(m => m._id);

               // Kachel zeigt die Aufteilung als Text — ohne Zeitreihe wäre
               // eine Grafik hier nur Dekoration.
               _this.userOS.summary = _this.userOS.result
                   .map(m => (m._id || 'Unbekannt') + ': ' + m.count)
                   .join('  ·  ');
               _this.userOS.amount = count.reduce((a, b) => a + b, 0);

               _this.userOS.chartData = {
                   labels: labels,
                   datasets: [{
                       data: count,
                       backgroundColor: '#664dc9',
                       backgroundColor: ['rgba(223, 217, 245, 0.3)', 'rgba(223, 217, 245, 0.6)'],
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               }
               _this.userOS.chartOptions = TILE_CHART_OPTIONS;
           }).catch(function(error) {
               _this.userOS.amount = null;
               _this.onError(error);
           });
       },
       fetchTopUserByDistance(time) {
           let _this = this;
           this.$axios.get('/user/top/distance/' + time + '/0/10').then(function (response) {
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               _this.topUsersByDistance.result = response.data.data;
               const drivenKilometers = _this.topUsersByDistance.result.map(m => m.drivenKilometers);
               const labels = _this.topUsersByDistance.result.map(m => m.userName);

               _this.topUsersByDistance.chartData = {
                   labels: labels,
                   datasets: [{
                       label: 'Anzahl der gefahrenen Kilometer',
                       data: drivenKilometers,
                       backgroundColor: '#664dc9',
                   }]
               }
               _this.topUsersByDistance.chartOptions = {
                   scales: {
                       yAxes: [{
                           ticks: {
                                min: 0,
                                reverse: false,
                            },
                       }]
                   },
                }
           }).catch(_this.onError);
       },
       fetchTopUserByPost(time) {
           let _this = this;
           this.$axios.get('/user/top/posts/' + time + '/0/10').then(function (response) {
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               _this.topUsersByPost.result = response.data.data;
               const count = _this.topUsersByPost.result.map(m => m.count);
               const labels = _this.topUsersByPost.result.map(m => m._id);

               _this.topUsersByPost.chartData = {
                   labels: labels,
                   datasets: [{
                       label: 'Anzahl der geteilten Beiträge',
                       data: count,
                       backgroundColor: '#664dc9',
                   }]
               }
               _this.topUsersByPost.chartOptions = {
                   scales: {
                       yAxes: [{
                           ticks: {
                                min: 0,
                                reverse: false,
                            },
                       }]
                   },
                }
           }).catch(_this.onError);
       },
       fetchLastPosts() {
           let _this = this;
           this.$axios.get('/post/all/0/10/-1').then(function (response) {
               // Ohne Prüfung schrieb eine Ablehnung "undefined" in lastPosts —
               // die Karte "Letzte Beiträge" blieb dann leer stehen bzw. der
               // ".length"-Zugriff im Erfolgszweig existiert hier nicht, aber
               // ein leeres Array ist ehrlicher als eine kaputte Antwort.
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               _this.lastPosts = response.data.data || [];
           }).catch(_this.onError);
       },
       /**
        * Trips je Tag für die Statistik in der Kachel.
        * Die Gesamtzahl kommt weiterhin aus der Kategorie-Auswertung, hier
        * geht es nur um den Verlauf von links nach rechts.
        */
       /** Rangliste der punktstärksten Nutzer. */
       fetchRanking() {
           let _this = this;
           this.$axios.get('/statistics/ranking/10').then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung liess die
               // Rangliste beim zuletzt geladenen Stand stehen, ohne Meldung.
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               _this.ranking = response.data.data || [];
           }).catch(_this.onError);
       },
       /** Rangliste der am häufigsten hinterlegten Fahrzeuge. */
       fetchVehicleRanking() {
           let _this = this;
           this.$axios.get('/statistics/vehicles').then(function (response) {
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               _this.vehicleRanking = response.data.data || { car: [], bike: [] };
           }).catch(_this.onError);
       },

       /** Wie oft jede Auszeichnung vergeben wurde. */
       fetchBadgeOverview() {
           let _this = this;
           this.$axios.get('/statistics/badges').then(function (response) {
               // FEHLER 5: badgeOverviewError geht im Template vor der
               // Leermeldung "Bisher wurde keine Auszeichnung vergeben." —
               // ohne das sah eine Ablehnung genauso aus wie echte Leere.
               if (response.data == null || response.data.success === false) {
                   _this.badgeOverviewError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                   _this.onError(response.data);
                   return;
               }
               _this.badgeOverviewError = '';
               _this.badgeOverview = response.data.data || [];
           }).catch(function (error) {
               _this.badgeOverviewError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
               _this.onError(error);
           });
       },

       /** Anteil geworbener Nutzer und die aktivsten Werber. */
       fetchReferrals() {
           let _this = this;
           this.$axios.get('/statistics/referrals').then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — die Empfehlungsquote
               // zeigte bei einer Ablehnung kommentarlos "0 von 0 Nutzern...,
               // 0 %". Jetzt bleiben total/recruited/share auf null
               // (displayNumber() zeigt "—") und referralsError erklärt warum.
               if (response.data == null || response.data.success === false) {
                   _this.referrals = { total: null, recruited: null, share: null, topReferrers: [] };
                   _this.referralsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                   _this.onError(response.data);
                   return;
               }
               _this.referralsError = '';
               _this.referrals = response.data.data || { total: null, recruited: null, share: null, topReferrers: [] };
           }).catch(function (error) {
               _this.referrals = { total: null, recruited: null, share: null, topReferrers: [] };
               _this.referralsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
               _this.onError(error);
           });
       },

       /** Wer über eine Empfehlung dazugekommen ist. */
       fetchRecruited() {
           let _this = this;
           this.$axios.get('/statistics/referrals/recruited/25').then(function (response) {
               // FEHLER 5: recruitedError geht im Template vor der Leermeldung
               // "Bisher wurde niemand über einen Werbecode geworben."
               if (response.data == null || response.data.success === false) {
                   _this.recruitedError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                   _this.onError(response.data);
                   return;
               }
               _this.recruitedError = '';
               _this.recruited = response.data.data || [];
           }).catch(function (error) {
               _this.recruitedError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
               _this.onError(error);
           });
       },

       /**
        * Gemeldete Nutzer und Inhalte mit Grund.
        *
        * FEHLER 1 (schwerster Befund): War ungeprüft — response.data.data
        * fehlt bei einer fachlichen Ablehnung (HTTP 200, success:false), das
        * bisherige "|| []" machte daraus stillschweigend eine leere Liste.
        * Auf dem Bildschirm stand danach "Keine Meldungen vorhanden." — der
        * Verwalter schloss daraus, es gäbe nichts zu tun, ausgerechnet auf der
        * Kachel, die Missbrauch sichtbar machen soll. Jetzt trennt
        * reportsLoading/reportsError "lädt" von "wirklich leer" von
        * "Abruf gescheitert" (Zustandskette im Template), und eine Ablehnung
        * erscheint zusätzlich als Meldung über $noty.error.
        */
       fetchReports() {
           let _this = this;
           this.reportsLoading = true;
           this.reportsError = '';
           this.$axios.get('/statistics/reports/20').then(function (response) {
               _this.reportsLoading = false;
               if (response.data == null || response.data.success === false) {
                   _this.reportsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
                   _this.onError(response.data);
                   return;
               }
               _this.reports = response.data.data || [];
           }).catch(function (error) {
               _this.reportsLoading = false;
               _this.reportsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
               _this.onError(error);
           });
       },

       /** Meldungsart in Klartext. */
       reportTypeLabel(type) {
           if (type === 'user') return 'Nutzer';
           if (type === 'post') return 'Beitrag';
           if (type === 'trip') return 'Trip';
           if (type === 'route') return 'Route';
           return type || '—';
       },

       /** Beiträge und Kommentare je Tag als zwei Verlaufslinien. */
       fetchActivity(time) {
           let _this = this;
           this.$axios.get('/statistics/activity/' + time).then(function (response) {
               // FEHLER 5: War ohne Erfolgsprüfung — eine Ablehnung liess das
               // Diagramm beim zuletzt geladenen Verlauf stehen.
               if (response.data == null || response.data.success === false) {
                   _this.onError(response.data);
                   return;
               }
               const data = response.data.data || { posts: [], comments: [] };
               // Beide Reihen auf dieselbe Tagesachse bringen, sonst verrutschen sie
               // gegeneinander, wenn an einem Tag nur eines von beidem vorkam.
               const days = [...new Set([...data.posts, ...data.comments].map(r => r._id))];
               const byDay = (rows) => {
                   const map = {};
                   rows.forEach(r => { map[r._id] = r.count; });
                   return days.map(d => map[d] || 0);
               };
               _this.activity.chartData = {
                   labels: days,
                   datasets: [
                       { label: 'Beiträge', data: byDay(data.posts),
                         backgroundColor: 'rgba(102, 77, 201, 0.25)', borderColor: 'rgba(102, 77, 201, 0.9)' },
                       { label: 'Kommentare', data: byDay(data.comments),
                         backgroundColor: 'rgba(99, 172, 190, 0.25)', borderColor: 'rgba(99, 172, 190, 0.9)' },
                   ]
               };
               _this.activity.chartOptions = {
                   maintainAspectRatio: false,
                   responsive: true,
                   elements: { point: { radius: 0 }, line: { tension: 0.4 } },
                   scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
               };
           }).catch(_this.onError);
       },

       /** Sorte einer Auszeichnung in Klartext. */
       badgeKindLabel(kind) {
           if (kind === 'once') return 'einmalig';
           if (kind === 'collectible') return 'sammelbar';
           if (kind === 'monthly') return 'monatlich';
           return kind;
       },

       fetchTripsByDate(time) {
           let _this = this;
           this.$axios.get('/trip/statistics/date/' + time).then(function (response) {
               // FEHLER 5 (namentlich genannt: Kachel "Trips"): War ohne
               // Erfolgsprüfung — eine Ablehnung liess amountOfTrips.amount
               // beim zuletzt geladenen Wert stehen, ohne jede Meldung.
               if (response.data == null || response.data.success === false) {
                   _this.amountOfTrips.amount = null;
                   _this.onError(response.data);
                   return;
               }
               const rows = response.data.data || [];
               // Kachelwert "Trips" aus derselben, bereits zeitgefilterten
               // Antwort bilden statt aus dem ungefilterten /home/dashboard
               // (siehe fetchRegisteredUsers) — sonst blieb die Zahl bei
               // jedem Zeitraumwechsel unverändert stehen.
               _this.amountOfTrips.amount = rows.reduce((pv, cv) => pv + cv.count, 0);
               _this.amountOfTrips.chartData = {
                   labels: rows.map(r => r._id),
                   datasets: [{
                       data: rows.map(r => r.count),
                       backgroundColor: 'rgba(223, 217, 245, 0.3)',
                       borderColor: 'rgba(223, 217, 245, 0.8)',
                   }]
               };
               _this.amountOfTrips.chartOptions = TILE_CHART_OPTIONS;
           }).catch(function (error) {
               _this.amountOfTrips.amount = null;
               _this.onError(error);
           });
       },
       fetchLastRewards(time) {
            let _this = this;
            this.$axios
                .post("/reward/history/all/0/10/" + time, { rewardSent: false })
                .then(function (response) {
                    _this.lastRewards.result = response.data.data;
                    const count = _this.lastRewards.result.map(m => m.count);
                    const labels = _this.lastRewards.result.map(m => m._id);

                    _this.lastRewards.chartData = {
                        labels: labels,
                        datasets: [{
                            label: 'test',
                            data: count,
                            backgroundColor: '#664dc9',
                        }]
                    }
                })
                .catch(function (error) {
                console.error(error);
                });
        },
        sendReward(rewardObject) {
            let _this = this;
            const rewardToSend = {
                rewardHistoryId: rewardObject._id,
                rewardSent: true,
            }

            this.$axios.post('/reward/history/status/update', rewardToSend).then(function(response) {
                _this.fetchLastRewards();
            }).catch(function(error){
                console.error(error);
            });
        },
       setTimePicker(timeSpan) {
           // Beim ersten Aufruf aus `mounted` sind die Einträge des Ausklappmenüs
           // noch nicht im Dokument. Ohne diese Prüfung wirft der Zugriff, und
           // fetchData bricht ab — sämtliche Auswertungen blieben dann leer.
           const current = document.getElementById('dropdown' + this.currentTimeSpan);
           const next = document.getElementById('dropdown' + timeSpan);

           if (current) current.classList.remove('active');
           if (next) next.classList.add('active');

           this.currentTimeSpan = timeSpan;
       },
       clickOnTableRow(name, params) {
		if(this.$route.name == name) {
			if(name == 'Users'){
				this.$root.$emit('Users', params.user);
			} else if(name == 'Events') {
				this.$root.$emit('Events', params.event);
			} else if(name == 'Trips') {
				this.$root.$emit('Trips', params.trip);
			} else if(name == 'Posts') {
				this.$emit('Posts', params.post);
			} else if(name == 'Rewards') {
				this.$root.$emit('Rewards', params.reward);
			}
		} else {
			this.$router.push({name: name, params: params});
		}
	},
   }
}
</script>

<style>
/* Startseite: kompakte KPI-Kacheln – große Zahl + Beschriftung, ohne die großen Diagramme (Ronny 2026-07-10) */
/* Kachel in zwei Hälften geteilt (Ronny 2026-08-04):
   oben Titel und Zahl nebeneinander, unten die Statistik über die volle Breite. */
.dash1-card { height: 132px !important; position: relative; overflow: hidden; }

.dash1-card .dashboardCard {
  height: 100% !important;
  min-height: 0 !important;
  display: block;
  padding: 0 !important;
}

/* Obere Hälfte: Beschriftung links, Zahl rechts */
.dash1-card .dashboardCard .row {
  height: 50%;
  width: 100%;
  margin: 0;
  padding: 0 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  position: static;
}

.dash1-card .dashboardCard .col-md-6 {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  max-width: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

/* Betriebssysteme bringt eine dritte Zeile mit — die darf umbrechen */
.dash1-card .dashboardCard .col-md-6 > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  flex-wrap: nowrap;
}

.dash1-card .number-font {
  font-size: 30px !important;
  line-height: 1;
  margin: 0 !important;
  white-space: nowrap;
}
.dash1-card .fs-14 { font-size: 14px; letter-spacing: .2px; }
/* Die Aufteilung darf die Kopfzeile nicht nach oben drücken — sie sitzt
   deshalb frei unterhalb, auf Höhe der Trennlinie zwischen den Hälften. */
.dash1-card .os-summary {
  position: absolute;
  left: 22px;
  right: 22px;
  top: 50%;
  margin-top: 2px;
  font-size: 11px !important;
  opacity: .8;
  white-space: nowrap;
}

/* Fußnote unter der Zahl (z. Zt. nur „Aktive Nutzer"): sitzt wie .os-summary
   auf Höhe der Trennlinie zwischen den beiden Hälften. Anders als .os-summary
   braucht sie ein z-index über der Kurve — die liegt in derselben Höhe und
   würde den Text sonst überdecken. Zu langer Text wird abgeschnitten statt
   umzubrechen: Die Kachel hat eine feste Höhe von 132px, ein Umbruch würde
   unten herausragen und abgeschnitten werden (overflow: hidden). */
.dash1-card .tile-footnote {
  position: absolute;
  left: 22px;
  right: 22px;
  top: 50%;
  margin-top: 2px;
  font-size: 11px;
  opacity: .8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 2;
}

/* Untere Hälfte: Statistik über die volle Breite, ohne Klickfang */
.dash1-card .headerChartContainer {
  display: block !important;
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 50%;
  margin: 0 !important;
  padding: 0 !important;
  opacity: .5;
  pointer-events: none;
  z-index: 0;
}
.dash1-card .headerChartContainer .chart-wrapper,
.dash1-card .headerChartContainer canvas {
  height: 100% !important;
  width: 100% !important;
  max-height: 100% !important;
}

/* Leichte globale Politur */
/* Abrundung kommt einheitlich aus public/css/rounded.css (10px, Ronny 2026-08-04) */
.table tbody tr { transition: background .12s ease; }
.table tbody tr:hover { background: rgba(99,172,190,.10); }

/* KPI-Kacheln enger zusammen (Ronny 2026-07-10) */
[class*="col-"]:has(.dash1-card) { padding-left: 6px; padding-right: 6px; }
.dash1-card { margin-bottom: 12px !important; }
</style>